import styled from 'styled-components';

import { stylesFor } from '../styles/utilities';

const Title = styled.span`
  color: ${props =>
    props.isLight ? props.theme.color.white : props.theme.color.gray19};
  display: block;
  font-size: 20px;
  font-weight: ${props => props.theme.font.weight.bold};
  line-height: 1.25;
  margin: 0 0 16px 0;

  ${stylesFor.mediumUp`
    font-size: 24px;
  `};

  ${stylesFor.xLargeUp`
    font-size: 40px;
    margin-bottom: 28px;
  `};
`;

const Link = styled.a`
  color: ${props => props.theme.color.sharePointTeal};
  font-size: 12px;
  font-weight: ${props => props.theme.font.weight.bold};
  letter-spacing: 1px;
  text-decoration: none;
  text-transform: uppercase;
`;

const Overview = styled.p`
  color: ${props => props.theme.color.gray19};
  font-size: 16px;
  line-height: 1.5;
  max-width: 800px;
  margin: 0 0 20px 0;

  ${stylesFor.mediumUp`
    font-size: 18px;
  `};

  ${stylesFor.xLargeUp`
    font-size: 24px;
    margin-bottom: 80px;
  `};
`;

export default { Title, Link, Overview };



// WEBPACK FOOTER //
// ./src/components/text.js